import React, { useCallback, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import IsNotSaved from '../IsNotSaved';
import useUpdateState from '../hooks/useUpdateState';
import { useErrorHandling } from '@rd-web-markets/shared/dist/hooks/useErrorHandling';
import omit from 'lodash.omit';
import { ChangeHighlighter, FormattedNumberInput } from '@rd-web-markets/shared/dist/util';
import generalRouteSubRouteService from '@rd-web-markets/shared/dist/services/general_route_subroute.service';
const WageCost = _ref => {
  let {
    financialYear,
    wageCosts,
    setWageCosts
  } = _ref;
  const {
    t
  } = useTranslation();
  const [isNotSaved, setIsNotSaved] = useState(false);
  const [updateState] = useUpdateState(setWageCosts, setIsNotSaved);
  const saveData = useErrorHandling(useCallback(async body => {
    const fieldValues = omit(body, ['id', 'elster_id', 'created_at', 'updated_at']);
    if (Object.values(fieldValues).some(value => value < 0)) {
      throw new Error('Values must be greater than 0');
    }
    const response = await generalRouteSubRouteService.update(body.elster_id, 'elsters', 'wage_cost', '', body);
    setWageCosts({
      ...response
    });
    setIsNotSaved(false);
  }, [setWageCosts]));
  const renderInput = field => {
    const isCurrency = ['gross_wages_of_employees_for_whom_income_tax_is_deducted', 'num_employees_with_no_tax_deduction_due_to_dta', 'gross_wages_employees_with_no_income_tax_due_to_dta', 'expenditure_to_secure_the_future_of_employees', 'gross_wages_employees_with_no_income_tax_in_rd_due_to_dta', 'gross_wages_employees_in_rd_projects_with_no_tax_deduct', 'expenditure_to_safeguard_the_future_of_employees_engaged_in_r_d'].includes(field[0]);
    return /*#__PURE__*/React.createElement("div", {
      key: field[0] + 'wageCostKey'
    }, /*#__PURE__*/React.createElement(ChangeHighlighter, {
      as: FormattedNumberInput,
      thousandSeparator: ".",
      decimalSeparator: ",",
      object: field,
      name: 1,
      type: "text",
      size: "sm",
      onlyPositiveNumbers: true,
      onChange: e => updateState({
        target: {
          value: e.target.value
        }
      }, wageCosts, field[0]),
      style: {
        width: '100px'
      }
    }));
  };
  const topPageTitle = /*#__PURE__*/React.createElement(Row, {
    className: "mb-5"
  }, /*#__PURE__*/React.createElement(Col, {
    md: 7
  }, t('information_on_total_wage_costs_in_the_enterprise')), /*#__PURE__*/React.createElement(Col, {
    md: 5
  }));
  const middlePageTitle = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(Row, {
    className: "mb-5"
  }, /*#__PURE__*/React.createElement(Col, {
    md: 7
  }, t('information_on_total_wage_costs_of_employees_engaged_in_r_d_in_the_enterprise')), /*#__PURE__*/React.createElement(Col, {
    md: 5
  })));
  const costRows = Object.entries(wageCosts).map((wC, index) => {
    if (['id', 'elster_id', 'created_at', 'updated_at'].includes(wC[0])) return null;
    return /*#__PURE__*/React.createElement("div", {
      key: wC[0] + 'wageCost'
    }, wC[0] === 'num_employees_in_enterprise_income_tax_is_deducted' && topPageTitle, wC[0] === 'num_employees_tax_deducted_by_full_time_eq' && middlePageTitle, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      md: 7
    }, /*#__PURE__*/React.createElement("p", null, t(wC[0]))), /*#__PURE__*/React.createElement(Col, {
      md: 1
    }, renderInput(wC, index))));
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 7
  }, t('financial_year')), /*#__PURE__*/React.createElement(Col, {
    md: 5
  }, financialYear)), /*#__PURE__*/React.createElement("hr", null), costRows, /*#__PURE__*/React.createElement(IsNotSaved, {
    isNotSaved: isNotSaved,
    save: saveData,
    paramsForUpdate: [wageCosts]
  }));
};
export default WageCost;